import { QuickTableColumn } from '../elements/QuickTable/QuickTableColumn';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import { QuickTableReactComponentView, QuickTableReactViewModel } from './QuickTableReactViewModel';
export class AutoCompleteQuickTableComponentView extends QuickTableReactComponentView {
}
export class AutoCompleteQuickTableViewMode extends QuickTableReactViewModel {
    get heightOfContainer() {
        return this.componentView.heightOfContainer;
    }
    set heightOfContainer(value) {
        this.updateComponentView('heightOfContainer', value);
    }
    get x() {
        return this.componentView.x;
    }
    set x(value) {
        this.updateComponentView('x', value);
    }
    get y() {
        return this.componentView.y;
    }
    set y(value) {
        this.updateComponentView('y', value);
    }
    constructor() {
        super(AutoCompleteQuickTableComponentView);
        this.onElementsCountChanged = this.onElementsCountChanged.bind(this);
    }
    update(props, prevProps) {
        if (isNullOrUndefined(props.autoCompleteQuickTableProps)) {
            return;
        }
        super.update(props, prevProps);
    }
    dispose() {
        this.quickTable.unsubscribeOnScrollElementsCountChanged(this.onElementsCountChanged);
        this.quickTable.OnSelectionChanged.UnSubscribe(this.onSelectionChanged, this);
        super.dispose();
    }
    onElementsCountChanged() {
        var _a, _b;
        const elementsCount = Math.min(this.props.maxElementsCount, this.quickTable.visibleRowCount());
        this.heightOfContainer = elementsCount * this.quickTable.rowHeight;
        (_b = (_a = this.props.autoCompleteQuicktableEvents) === null || _a === void 0 ? void 0 : _a.onElementsCountChanged) === null || _b === void 0 ? void 0 : _b.call(_a, elementsCount);
        this.adjustPositionToFitWindow();
    }
    onSelectionChanged(fromMouseClick) {
        this.props.autoCompleteQuicktableEvents.onAutoCompliteSelectionChanged(fromMouseClick);
    }
    getNewQuickTable(context) {
        const quickTable = super.getNewQuickTable(context);
        quickTable.columns.push(new QuickTableColumn());
        quickTable.UpdateSortedColumns();
        quickTable.subscribeOnScrollElementsCountChanged(this.onElementsCountChanged);
        quickTable.OnSelectionChanged.Subscribe(this.onSelectionChanged, this);
        quickTable.setShowColumnHeaders(false);
        return quickTable;
    }
    adjustPositionToFitWindow() {
        const correctLocation = ControlsUtils.adjustPositionToFitWindow(this.props.x, this.props.y, this.props.width, this.height);
        this.x = correctLocation.x;
        this.y = correctLocation.y;
    }
}
